<template>
  <BaseNavItem
    :title="$t('labels.clients')"
    :icon="$vuetify.icons.values.clients"
    :route="targetRoute"
    :visible="visible"
  />
</template>

<script>
import { mapState } from 'vuex'
import { BaseNavItem } from '@argon/app/components'
import clientPerimeter from '../perimeters'

export default {
  components: { BaseNavItem },
  perimeters: [clientPerimeter],
  computed: {
    targetRoute() {
      return {
        name: 'clients',
        params: this.$route.params
      }
    },
    visible() {
      return this.$client.isAllowed('atLeastAdvisor')
    }
  }
}
</script>
